<template>
  <div class="wrapper">
    <div class="container" v-if="isVip!=1">
      <img src="@/assets/images/banner.png" class="banner" />
      <div class="section">
        <p>您好！我们是一家可以为您提供定制化服务的一体化解决方案科技公司。</p>
        <p>我们可以为您提供如下服务：</p>
        <ul class="service-list">
          <li>1.为您提供一套完备的管理系统</li>
          <li>2.为您提供一个可以供客户下单的免费小程序</li>
          <li>3.为您做精准引流 让更多的客户可以看到您~</li>
        </ul>
      </div>
      <div class="section">
        <p>注册可能会花费您3-5分钟时间~</p>
        <p>如果您是企业、个体户，请您准备好营业执照、法人身份证、结算收款银行卡。</p>
        <p>如果您是个人用户，请您提前准备好您的身份证、结算收款银行卡。</p>
      </div>
      <div class="section qualifi-section">
        <p>支付、结算全流程由易宝支付提供，查看《<span class="remarks" @click="toPreviewImg">中华人民共和国支付业务资质</span>》。</p>
      </div>
    </div>
    <div class="container" v-if="isVip==1">
      <img src="@/assets/images/banner.png" class="banner" />
      <div class="section">
        <p>我们可以为您提供如下服务：</p>
        <ul class="service-list">
          <li>1.为您提供一套完备的门店、私域流量管理系统</li>
          <li>2.为您提供一个可以供客户下单的小程序或H5页</li>
          <li>3.为您做精准引流 让更多的客户可以看到您~</li>
        </ul>
      </div>
      <div class="section">
        <p>注册可能会花费您3-5分钟时间~</p>
        <p>如果您是企业、个体户，请您准备好营业执照、法人身份证、结算收款银行卡。</p>
        <p>如果您是个人用户，请您提前准备好您的身份证、结算收款银行卡。</p>
      </div>
      <div class="section qualifi-section">
        <p>支付、结算全流程由易宝支付提供，查看《<span class="remarks" @click="toPreviewImg">中华人民共和国支付业务资质</span>》。</p>
      </div>
    </div>
    <div class="footer-bar"></div>
    <div class="footer">
      <div class="submit-btn" @click="goBack">我知道了</div>
    </div>
    <ContactBtn />
  </div>
</template>


<script>
import { ImagePreview } from 'vant';
import { getCategory } from '@/api/baseinfo';

export default {
  name: 'guide',
  data () {
    return {
      isVip: sessionStorage.getItem('isVip')||0,
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
      imgUrl: undefined
    }
  },
  created() {
    this.getQualificationImg();
  },
  methods: {
    toPreviewImg() {
      if(!this.imgUrl) return this.Toast('支付业务资质图片加载失败，请稍后再试~');
      ImagePreview({
        images: this.imgUrl ? [this.imgUrl] : [],
        closeable: true	
      })
    },
    goBack() {
      let phone = sessionStorage.getItem('phone');
      let userAscription = sessionStorage.getItem('userAscription');
      localStorage.setItem('flag', true);
      if(!phone&&!userAscription) return this.$router.replace('/');
      if(phone&&userAscription) {
        this.$router.replace('/?phone='+phone+'&userAscription=' + userAscription);
      } else {
        if(userAscription) {
          this.$router.replace('/?userAscription=' + userAscription);
        }
        if(phone) {
          this.$router.replace('/?phone='+phone);
        }
      }
    },
    getQualificationImg() {
      getCategory('CS20220610102').then(res => {
        if(res.data && res.data.length > 0) {
          this.imgUrl = res.data[0].constantImg;
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width:750px){
  .container{
    padding-top: 1px;
    padding-bottom: 50px;
    position: relative;
  }
  .banner{
    width: 16.75rem;
    height: 8.2rem;
    display: block;
    margin: 1.2rem auto .8rem;
    border-radius: .8rem;
  }
  .section{
    width: 16.75rem;
    margin: 0 auto 1.25rem;
    p{
      line-height: 1.5;
      font-size: .7rem;
      color: #222;
      text-align: left;
      margin-bottom: .25rem;
      .remarks{
        font-size: .7rem;
        color: $base-color;
        cursor: pointer;
      }
    }
    .service-list{
      margin-bottom: 1.25rem;
      li{
        line-height: 1.5;
        font-size: .7rem;
        color: #222;
        text-align: left;
        margin-bottom: .25rem;
        font-weight: 600;
      }
    }
  }
  .qualifi-section{
    margin-bottom: 0;
  }
  .footer {
    bottom: 0;
  }
}
@media screen and (min-width:750px){
  .banner{
    width: 335px;
    height: 164px;
    display: block;
    margin: 24px auto 16px;
    border-radius: 16px;
  }
  .section{
    width: 335px;
    margin: 0 auto 25px;
    p{
      line-height: 1.5;
      font-size: 14px;
      color: #222;
      text-align: left;
      margin-bottom: 5px;
      NaNpxarks{
        font-size: 14px;
        color: $base-color;
        cursor: pointer;
      }
    }
    .service-list{
      margin-bottom: 25px;
      li{
        line-height: 1.5;
        font-size: 14px;
        color: #222;
        text-align: left;
        margin-bottom: 5px;
        font-weight: 600;
      }
    }
  }
  .qualifi-section{
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/guide.vue